import debounce from 'lodash/debounce.js';
import { getSellerId } from 'dibs-cookie-jar';
import serverVars from 'server-vars';
import { GLOBAL_CLIENT_ONLY_LOCALE, handleLocaleUrl } from 'dibs-intl/exports/urls';
import { urlForward } from '../../server/authentication/helpers/urlForward.ts';
import { SELLER_LOGIN, SERVER_VARS } from '../../server/constants.ts';

const shouldEnsureSellerToken =
    !!serverVars.get(SERVER_VARS.requiresLogin) &&
    serverVars.get('shouldRedirectExpiredTokenSellerFF');

const ensureSellerTokenOrRedirect = (): void => {
    if (!shouldEnsureSellerToken) return;

    const sellerId = getSellerId(document.cookie);
    if (sellerId) return;

    window.location.replace(
        handleLocaleUrl(
            urlForward({
                fullUrlString: window.location.href,
                pathRoot: SELLER_LOGIN,
            }),
            GLOBAL_CLIENT_ONLY_LOCALE
        )
    );
};

const debouncedEnsureSellerTokenOrRedirect = debounce(ensureSellerTokenOrRedirect, 5000, {
    leading: true,
    trailing: false,
});

// There's a proper API for this, but it's not supported by all browsers yet (in 2026)
// If you are looking at this code in 2028+, please refactor.
// https://developer.mozilla.org/en-US/docs/Web/API/CookieStore/change_event

document.addEventListener('pageshow', debouncedEnsureSellerTokenOrRedirect);
document.addEventListener('click', debouncedEnsureSellerTokenOrRedirect, true);
document.addEventListener('keydown', debouncedEnsureSellerTokenOrRedirect, true);
document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
        debouncedEnsureSellerTokenOrRedirect();
    }
});
